import { IPublishOption } from '../../../redux/reducers';
import { plural } from '@cian/utils';

const DAY_VARIANTS: [string, string, string] = ['день', 'дня', 'дней'];

export function formatPeriodName(period: IPublishOption): string {
  const { days } = period;

  if (days === 1) {
    return 'Посуточно';
  }

  return `${days} ${plural(days, DAY_VARIANTS)}`;
}
